var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"data-track":"monitors-results-placeholder"}},_vm._l((12),function(item,i){return _c('v-col',{key:i,staticClass:"d-flex",style:({ opacity: 1 - (i * 0.08) }),attrs:{"cols":"12"}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-skeleton-loader',{attrs:{"type":"list-item-three-line"}}),_c('v-divider')],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }